import { render, staticRenderFns } from "./detailModel.vue?vue&type=template&id=480daf90&scoped=true"
import script from "./detailModel.vue?vue&type=script&lang=js"
export * from "./detailModel.vue?vue&type=script&lang=js"
import style0 from "./detailModel.vue?vue&type=style&index=0&id=480daf90&prod&scoped=true&lang=css"
import style1 from "./detailModel.vue?vue&type=style&index=1&id=480daf90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480daf90",
  null
  
)

export default component.exports